import clsx from 'clsx';
import { ReactNode, useCallback } from 'react';
import { HelpCircle } from 'react-feather';

import { AnalyticsEvent, OpenHelpDimensions, logAnalyticsEvent } from '@vestico/utils';

import globalStyle from '@vestico/shared/src/layouts/utils.module.css';

import style from './HelpPopover.module.css';
import { Horizontal, Popover, PopoverPosition, Vertical } from './Popover';

const HELP_BUTTON_SIZE = 24;

export interface HelpPopoverProps {
  helpText?: ReactNode;
  id: string;
  position?: PopoverPosition;
}

export const HelpPopover = ({ helpText, id, position }: HelpPopoverProps) => {
  const onHelpOpen = useCallback(() => {
    logAnalyticsEvent({
      category: 'event',
      event: AnalyticsEvent.openHelp,
      dimensions: { provider: undefined, type: id } as OpenHelpDimensions,
    });
  }, [id]);

  if (!helpText) {
    return null;
  }
  return (
    <div className={clsx(style.helpWrapper)}>
      <Popover
        activator={
          <div style={{ width: HELP_BUTTON_SIZE, height: HELP_BUTTON_SIZE }}>
            <HelpCircle color="var(--color)" size={HELP_BUTTON_SIZE} />
          </div>
        }
        backgroundColor="var(--color-bg-secondary)"
        position={position ?? { horizontal: Horizontal.center, vertical: Vertical.top }}
        contentWidth="240px"
        didOpen={onHelpOpen}
      >
        <div className={clsx(globalStyle.textSmall)}>{helpText}</div>
      </Popover>
    </div>
  );
};
